// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_2IbTgo","grid":"_2Jbiqk","centered-section-spacing":"_3ESI6W","grid-odd":"_4uH2IB","container":"_3xacCg","cardsContainer":"_3RmW1e"};